const resources = {
  "en": {
    "common": {
      "headerTitle": "FinApp",
      "footerText": "FinApp © 2019-{{year}}",
      "footerOrigin": "The idea was born in Kherson, Ukraine, and brought to life in Brooklyn, USA.",
      "footerReleaseLabel": "Release",
      "category": "Category",
      "summary": "Summary",
      "total": "Total",
      "transactions": "Transactions",
      "categories": "Categories",
      "uncategorized": "No category",
      "notAssigned": "Not assigned",
      "common": {
        "summary": "Summary",
        "total": "Total",
        "transactions": "Transactions",
        "categories": "Categories",
        "uncategorized": "No category",
        "category": "Category",
        "notAssigned": "Not assigned"
      },
      "pagination": {
        "records": "{{rangeStart}}-{{rangeEnd}} of {{total}} records",
        "itemsPerPage": "items/page"
      },
      "floatingNav": {
        "top": "Top",
        "details": "Details",
        "chat": "Chat",
        "input": "Write"
      },
      "sectionNav": {
        "label": "Jump to",
        "top": "Top",
        "details": "Details",
        "chat": "Chat",
        "input": "Write"
      },
      "appRuntime": {
        "offline": "Offline",
        "forceRefresh": "Refresh app",
        "debug": {
          "toggle": "Runtime",
          "title": "Runtime Debug",
          "hide": "Hide",
          "buildVersion": "buildVersion",
          "isStandalone": "isStandalone",
          "online": "online",
          "swState": "swState",
          "authHydrated": "authHydrated",
          "authState": "authState",
          "authenticated": "authenticated",
          "guest": "guest",
          "bootAt": "bootAt",
          "lastEvent": "lastEvent",
          "lastError": "lastError"
        }
      },
      "pushTest": {
        "title": "Push test target",
        "description": "This route confirms that declarative push navigate points to a valid HTTPS page inside the installed web app.",
        "runtimeMode": "Runtime mode",
        "permission": "Notification permission",
        "currentUrl": "Current URL",
        "focusCheck": "Focus / Do Not Disturb must be off on the device if alerts are expected as banners."
      }
    }
  },
  "uk": {
    "common": {
      "headerTitle": "FinApp",
      "footerText": "FinApp © 2019-{{year}}",
      "footerOrigin": "Ідея народилася в Херсоні, Україна, а реалізувалася в Брукліні, США.",
      "footerReleaseLabel": "Реліз",
      "category": "Категорія",
      "summary": "Підсумок",
      "total": "Разом",
      "transactions": "Транзакції",
      "categories": "Категорії",
      "uncategorized": "Без категорії",
      "notAssigned": "Не призначено",
      "common": {
        "summary": "Підсумок",
        "total": "Разом",
        "transactions": "Транзакції",
        "categories": "Категорії",
        "uncategorized": "Без категорії",
        "category": "Категорія",
        "notAssigned": "Не призначено"
      },
      "pagination": {
        "records": "{{rangeStart}}-{{rangeEnd}} із {{total}} записів",
        "itemsPerPage": "записів/стор."
      },
      "floatingNav": {
        "top": "Вгору",
        "details": "Деталі",
        "chat": "Чат",
        "input": "Написати"
      },
      "sectionNav": {
        "label": "Перейти",
        "top": "Вгору",
        "details": "Деталі",
        "chat": "Чат",
        "input": "Написати"
      },
      "appRuntime": {
        "offline": "Офлайн",
        "forceRefresh": "Оновити застосунок",
        "debug": {
          "toggle": "Рантайм",
          "title": "Діагностика рантайму",
          "hide": "Сховати",
          "buildVersion": "версія збірки",
          "isStandalone": "standalone",
          "online": "мережа",
          "swState": "стан SW",
          "authHydrated": "auth hydrated",
          "authState": "стан auth",
          "authenticated": "авторизовано",
          "guest": "гість",
          "bootAt": "старт застосунку",
          "lastEvent": "остання подія",
          "lastError": "остання помилка"
        }
      },
      "pushTest": {
        "title": "Цільова сторінка push-тесту",
        "description": "Цей маршрут підтверджує, що declarative push navigate веде на валідну HTTPS-сторінку всередині встановленого вебзастосунку.",
        "runtimeMode": "Режим рантайму",
        "permission": "Дозвіл на сповіщення",
        "currentUrl": "Поточний URL",
        "focusCheck": "Для banner-алертів на пристрої мають бути вимкнені Focus / Do Not Disturb."
      }
    }
  }
};

export default resources;
